// extracted by mini-css-extract-plugin
export var alt = "ReservationCancelDialog-module--alt--6c3a6";
export var desktopOnly = "ReservationCancelDialog-module--desktopOnly--b746c";
export var main = "ReservationCancelDialog-module--main--c7eff";
export var mobileOnly = "ReservationCancelDialog-module--mobileOnly--e7ce0";
export var styledDialog = "ReservationCancelDialog-module--styledDialog--e32e8";
export var textLeft = "ReservationCancelDialog-module--textLeft--b3fcf";
export var visuallyHidden = "ReservationCancelDialog-module--visuallyHidden--6cf86";